export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "seller_sales",
      layout: "dashboard",
    },
    path: "/seller-sales",
    name: "seller-sales",
    component: () => import("@/layouts/index/SellerSaleIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste de ventes vendeurs",
          layout: "dashboard",
        },
        path: "index",
        name: "seller-sales-index",
        component: () => import("@/views/seller-sales/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer une vente vendeur",
          layout: "dashboard",
        },
        path: "create",
        name: "seller-sales-create",
        component: () => import("@/views/seller-sales/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la vente vendeur",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "seller-sales-edit",
        component: () => import("@/views/seller-sales/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails de la vente vendeur",
          layout: "dashboard",
        },
        path: ":reference/details",
        name: "seller-sales-details",
        component: () => import("@/views/seller-sales/Details.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "L'ajout des articles à une vente vendeur",
          layout: "dashboard",
        },
        path: "items/create",
        name: "seller-sales-items-create",
        component: () => import("@/views/seller-sales/items/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier les articles d'une vente vendeur",
          layout: "dashboard",
        },
        path: ":reference/items/edit",
        name: "seller-sales-items-edit",
        component: () => import("@/views/seller-sales/items/Edit.vue"),
      },
    ],
  },
];
